import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "foquz-icon-check-bold",
  "use": "foquz-icon-check-bold-usage",
  "viewBox": "0 0 8 6",
  "content": "<symbol viewBox=\"0 0 8 6\" fill=\"none\" id=\"foquz-icon-check-bold\"><path d=\"M1 2.708L3.324 5l3.614-4\" stroke=\"currentColor\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol